import {createSelector} from "reselect";

const Users = (state) => state.users;

export const getUserModalStatus = createSelector(Users, (Users) => Users.userModalStatus);

export const getUserModalData = createSelector(Users, (Users) => Users.userModalData);

const userData = createSelector(Users, (Users) => Users?.usersData || {});

export const getUsersList = createSelector(userData, (data) => data?.results || []);

export const getTotalCount = createSelector(userData, (data) => data?.count);

export const getUsersPaginationUrls = createSelector(userData, (data) => ({
  prevUrl: data?.previous,
  nextUrl: data?.next,
}));

export const getUserProfile = createSelector(Users, (Users) => Users.profile);

export const getUserSettings = createSelector(
  getUserProfile,
  (getUserProfile) => getUserProfile?.settings || {}
);
